export default {"src":"/_next/static/media/chapter-4-icon-circular.5a6cbb55.svg","height":137,"width":137,"blurWidth":0,"blurHeight":0};